import { DefaultOptionType } from '@bugly/common';
import { CharacterInput, CharacterInputValue, CustomInputRenderProps } from '@tencent/tds-ui';
import { useControllableValue } from 'ahooks';
import { InputNumberProps, SelectProps } from 'antd';
import React, { useRef } from 'react';
import { TdsNumberInputProps } from '@/presentation/components/tds-form/tds-number-input';
import { TdsInputNumberRange } from '@/presentation/components/tds-form/tds-number-range';
import { BaseFormItemProps, PropsWithStyles } from '@/presentation/components/tds-form/type';

export interface TdsCustomRangeProps<T = any> extends BaseFormItemProps<T> {
  modeSelectProps?: SelectProps;
  valueSelectProps?: InputNumberProps;
  modeOptions?: DefaultOptionType[];
  defaultActiveFirstMode?: boolean;
}


export const TdsCustomRange = (props: PropsWithStyles<TdsNumberInputProps>) => {
  const [value, setValue] = useControllableValue<CharacterInputValue>(props, {
    defaultValue: {
      mode: undefined,
      values: undefined,
    },
  });

  const ref = useRef<any>();

  const {
    valueSelectProps,
    modeSelectProps,
    modeOptions = [],
    defaultActiveFirstMode = true,
  } = props;

  const customInputRender = (params: CustomInputRenderProps) => (<TdsInputNumberRange
    {...valueSelectProps}
    value={params.value}
    onChange={params.onChange}
  />);

  return (
    <CharacterInput
      className={props.className}
      style={props.style}
      ref={ref}
      value={value}
      defaultActiveFirstMode={defaultActiveFirstMode}
      modeSelectProps={{
        dropdownMatchSelectWidth: 100,
        options: modeOptions,
        ...modeSelectProps,
      }}
      customInputRender={customInputRender}
      onChange={(value) => {
        setValue(value);
      }}
    />
  );
};
